import React, { useEffect, useState } from 'react';
import { getInitials } from '../../../utils';
import './style.less';

interface Props {
    src?: string;
    /** Photos to try in order; the next one is used if a link fails to load. Takes precedence over src. */
    srcs?: string[];
    firstName?: string;
    lastName?: string;
    className?: string;
}

const Avatar = ({ src, srcs, firstName, lastName, className }: Props) => {
    const candidates = srcs && srcs.length ? srcs : src ? [src] : [];
    const candidatesKey = candidates.join('|');
    const [failedCount, setFailedCount] = useState(0);
    useEffect(() => setFailedCount(0), [candidatesKey]);
    const initials = getInitials(firstName, lastName);
    const currentSrc = candidates[failedCount];

    if (currentSrc) {
        return (
            <img
                className={className}
                src={currentSrc}
                alt={`${firstName || ''} ${lastName || ''}`}
                onError={() => setFailedCount((count) => count + 1)}
            />
        );
    }

    return (
        <div className={`avatar-initials${className ? ` ${className}` : ''}`}>
            {initials || '?'}
        </div>
    );
};

export default Avatar;
